<template>
    <div id="app">
        <a-config-provider :locale="locale">
            <keep-alive v-if="isLogin" v-for="(item, index) in data" :key="index">
                <router-view v-if="$route.meta.name == item"></router-view>
            </keep-alive>
            <router-view v-if="!$route.meta.keepAlive || !isLogin"></router-view>
        </a-config-provider>
        <GloboalTips/>
    </div>
</template>
<script>
import { getToken } from '@/store/cookies'
import zhCN from 'ant-design-vue/lib/locale-provider/zh_CN'
import GloboalTips from '@/components/globalTips'
export default {
    data() {
        return {
            // data: ['监控管理', '故障列表', '上下线记录', '波形图', '设备升级', 'Log调试信息', '校验电梯', '故障视频'],
            data: [],
            isLogin: false,
            locale: zhCN,
            platform: '',
        }
    },
    components: {
        GloboalTips
    },
    watch: {
        $route(to, from) {
            const token = getToken()
            if (token) {
                this.isLogin = true
            } else {
                this.isLogin = false
            }
        },
    },
}
</script>
<style lang="scss">
.tips-wrapper {
    width: 100vh;
    height: 100vh;
    background-color: rgba(0, 0, 0, 0.3);
}
</style>